import React from "react";
import product1 from "../assets/images/ecommerce/product-table-1.png";
import product2 from "../assets/images/ecommerce/product-table-2.png";
import product3 from "../assets/images/ecommerce/product-table-3.png";
import product4 from "../assets/images/ecommerce/product-table-4.png";
import product5 from "../assets/images/ecommerce/product-table-5.png";
import product6 from "../assets/images/ecommerce/product-table-6.png";
import product7 from "../assets/images/ecommerce/product-table-1.png";
import product8 from "../assets/images/ecommerce/product-table-2.png";
import product9 from "../assets/images/ecommerce/product-table-3.png";
import product10 from "../assets/images/ecommerce/product-table-4.png";

export const data = [
  {
    image: <img src={product1} alt="" />,
    product_Name: "Red Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$10",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product2} alt="" />,
    product_Name: "Pink Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$12",
    stock: <div className="font-danger">Out of Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product3} alt="" />,
    product_Name: "Gray Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$15",
    stock: <div className="font-danger">Out of Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product4} alt="" />,
    product_Name: "Green Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$18",
    stock: <div className="font-primary">Low Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product5} alt="" />,
    product_Name: "Black Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$30",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product6} alt="" />,
    product_Name: "White Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$40",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product7} alt="" />,
    product_Name: "light Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$35",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product8} alt="" />,
    product_Name: "Gliter Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$25",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product9} alt="" />,
    product_Name: "Yellow Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$22",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
  {
    image: <img src={product10} alt="" />,
    product_Name: "Green Lipstick",
    product_desc:
      "Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens",
    amount: "$38",
    stock: <div className="font-success">In Stock</div>,
    start_date: "2023/4/25",
    action: (
      <div>
        <span>
          <i
            className="fa fa-trash"
            style={{ width: 35, fontSize: 16, padding: 11, color: "#e4566e" }}
          ></i>
        </span>
        <span>
          <i
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 16,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      </div>
    ),
  },
];
